import { render, staticRenderFns } from "./fallback-preview.vue?vue&type=template&id=e747c114&scoped=true&"
import script from "./fallback-preview.vue?vue&type=script&lang=ts&"
export * from "./fallback-preview.vue?vue&type=script&lang=ts&"
import style0 from "./fallback-preview.vue?vue&type=style&index=0&id=e747c114&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e747c114",
  null
  
)

export default component.exports